import axios from "axios";
import React, { useEffect, useState,useContext } from "react";
import {
  // Grommet,
  grommet,
  // Anchor,
  // Header,
  // Nav,
  // Menu,
  // ResponsiveContext,
} from "grommet";
import { deepMerge } from "grommet/utils";
import Startcourse from "./Startcourse";
import Coursecontent from "../Learner/Coursecontent";
import QandA from "../Learner/QandA";
import Assesment from "../Learner/Assesment";
import Webinar from "../Learner/Webinar";
import Review from "../Learner/Review";
import Quiz from "../Learner/LearnerQuiz/Quiz";
import Announcement from "../Learner/Announcement";
import { UserContext } from "../../context/UserContext";
import { Redirect, useHistory } from "react-router";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import { Icon } from "@material-ui/core";
import { toast } from "react-toastify";
// import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
// import VideoCallIcon from '@material-ui/icons/VideoCall';
// import RateReviewIcon from '@material-ui/icons/RateReview';
// import VolumeUpIcon from '@material-ui/icons/VolumeUp';

const myTheme = deepMerge(grommet, {
  tabs: {
    header: {
      border: {
        side: "bottom",
        color: "blue",
        size: "small",
      },
    },
  },
  tab: {
    border: {
      side: "bottom",
      color: "dark-4",
    },
    pad: "small",
    margin: {
      // bring the overall tabs border behind invidual tab borders
      vertical: "-2px",
      horizontal: "none",
    },
  },
});

const Courseheader = (props) => {
  let history = useHistory();
  const context = useContext(UserContext)
  const [coursesmenu, setcoursesmenu] = useState([]);
  const [myview, setmyview] = useState("over-view");
  const [value, setValue] = React.useState(0);
  const [redirect, setRedirect] = useState(false);
  const handleChange = (event, newValue) => { 
    setValue(newValue);
  };
  if (props?.location?.state?.coflearner) {
    localStorage.setItem("state", props.location.state.coflearner);
  }
  useEffect(() => {
    getAllCourses();
  }, [localStorage.getItem("state")]);
  const getAllCourses = async () => {

    if(!context.user?.email)
    {
      return
    }
    var formData = new FormData();
    var varvalue = window.location.pathname.replace("/Learner/", "");
    formData.append("type", localStorage.getItem("state"));
    formData.append("varvalue", varvalue);
    axios
      .post("Sample/coursemenu",formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
         if(!res.data.flag)
         {
          redirecttohome(res.data.msg);
         }
         
          setcoursesmenu(res.data.one);
          // console.log(res.data.one);
          setmyview("over-view")
          setValue(0)
          
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const redirecttohome = (msg) => {
    toast.error(msg, {
      position: toast.POSITION.BOTTOM_LEFT,
    });
history.push({
            pathname: "/",
          });
  }
  if (!context.user?.email) {
    
    return <Redirect to="/Signin" />

  }

  if(redirect)
  {
    return <Redirect to="/Signin" />
  }
  return (
    <div>
      <section className="courseschedule  course-header-content">
        {/* <Grommet theme={myTheme}>
          <Tabs justify="start" alignControls="start">
            {coursesmenu.map((item) => (
              <>
               <Tab title={item.path} onClick={(e) => setmyview(item.path)}>
             </Tab>
             <button color="primary" onClick={(e) => setmyview(item.path)}>
                {item.path}
              </button> 
              </>
            ))}
          </Tabs>
        </Grommet> */}
        <Paper square>
      <Tabs
        value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="on"
          indicatorColor="primary"
          aria-label="scrollable force tabs example"
      >
         {coursesmenu.map((item) => (
        <Tab 
        label={item.linkname} 
        icon={<Icon> {item.src} 
        </Icon>}
        onClick={(e) => setmyview(item.path)}/>
        ))}
      </Tabs>
    </Paper>
        {/* <Grommet theme={myTheme}>
          <Header className="pl-5 ml-5" pad="medium">
            <ResponsiveContext.Consumer>
              {(responsive) =>
                responsive === "small" ? (
                  <Menu className="text-tabs-course "
                    label="My Menu"
                    items={coursesmenu.map((item) => ({
                      label: item.path,
                      onClick: (e) => setmyview(item.path),
                    }))}
                  />
                ) : (
                  <Nav direction="row" className="text-tabs-course ">
                    {coursesmenu.map((item) => (
                      <Anchor
                        label={item.path}
                        className=""
                        onClick={(e) => setmyview(item.path)}
                      />
                    ))}
                    
                  </Nav>
                )
              }
            </ResponsiveContext.Consumer>
          </Header>
        </Grommet> */}
        {(() => {

switch (myview) {
 case 'over-view':
     return <Startcourse/>
 case 'course-content':
    return  <Coursecontent/>
 case 'qanda':
    return  <QandA/>
 case 'assesment':
    return  <Assesment/>
 case 'webinar':
    return  <Webinar/>
    case 'quiz':
    return  <Quiz/>
case 'review':
    return  <Review/>
     case 'announcement':
    return  <Announcement/>
 default:
  return <Startcourse/>
}

})()}
      </section>
      
    </div>
  );
};

export default Courseheader;